<mat-form-field floatLabel="never" [ngClass]="classField()">
    <mat-select placeholder="..." [formControl]="control()">
        <mat-option [value]="'Regular'"><span translate>Regular / independent</span></mat-option>
        <mat-option [value]="'RoomRental'"><span translate>Room rental</span></mat-option>
        <mat-option [value]="'HouseSharing'"><span translate>Living group / house sharing</span></mat-option>
        <mat-option [value]="'ShortStay'"><span translate>Short stay</span></mat-option>
    </mat-select>
  </mat-form-field>